<template>
  <div class="">
    <div
      class="flex items-center w-8 h-8 rounded-full justify-center text-white text-lg font-bold bg-gray-300 hover:bg-gray-400 cursor-pointer ml-5"
      @click="openPicker()"
    >
      ˅
    </div>

    <transition name="fade">
      <div
        v-if="pickerOpened"
        class="flex flex-wrap absolute w-full mt-10 bg-gray-200 sm:rounded sm:shadow p-2 text-lg"
        style="
          width: fit-content;
          background: rgb(255, 255, 255);
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          -ms-border-radius: 5px;
          -o-border-radius: 5px;
          box-shadow: 0px 0px 2px 1px gainsboro;
          z-index: 888;
        "
      >
        <div class="flex w-full pb-2">
          <div class="w-2/4"></div>
        </div>

        <div class="">
          <div
            class="flex flex-grow cursor-pointer"
            @click="closePicker(), openReply()"
          >
            <i><svg-icon name="reply" /></i>
            Reply
          </div>
          <!-- <div
            class="flex flex-grow cursor-pointer mt-2"
            @click="closePicker(), emojiOptions()"
          >
            <i><svg-icon name="emoji" /></i>
            React
          </div> -->
          <div
            class="flex flex-grow cursor-pointer mt-2"
            @click="copy(message.text)"
          >
            <i><svg-icon name="copy" /></i>Copy
          </div>
          <!-- <div class="flex flex-grow cursor-pointer mt-2">
            <i><svg-icon name="forward" /></i>Forward
          </div> -->
          <div
            class="flex flex-grow cursor-pointer mt-2"
            v-if="
              message.sender &&
              $store.state.authuser &&
              message.sender.id == $store.state.authuser.id
            "
            @click="deleteMessage(), closePicker()"
          >
            <i><svg-icon name="delete" /></i>Delete
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { events } from "../events";
import vClickOutside from "click-outside-vue3";
import SvgIcon from "./SvgIcon";
import ReactionThread from "./ReactionThread";
import useClipboard from "vue-clipboard3";
import { useToast } from "vue-toastification";
const { toClipboard } = useClipboard();
const toast = useToast();
export default {
  components: {
    SvgIcon,
    ReactionThread,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    message: Object,
    index: Object,
  },
  data() {
    return {
      pickerOpened: false,
      emojis: [
        {
          name: ":thumbs_up:",
          emoji: "😍",
        },
        {
          name: ":thumbs_down:",
          emoji: "❤️",
        },
        {
          name: ":smile:",
          emoji: "😁",
        },
        {
          name: ":tada:",
          emoji: "🤪",
        },
        {
          name: ":confused:",
          emoji: "😕",
        },
        {
          name: ":heart:",
          emoji: "😂",
        },
        {
          name: ":rocket:",
          emoji: "😉",
        },
        {
          name: ":raising:",
          emoji: "🙌",
        },
      ],
    };
  },
  mounted() {
    var self = this;

    window.HyreadsEvents.on(events.CLOSE_ALL_REACTION_PICKERS, () => {
      self.pickerOpened = false;
    });
  },
  methods: {
    async copy(copied) {
      try {
        await toClipboard(copied);
        console.log(copied);
        toast.success("copied");
      } catch (e) {
        console.error(e);
        toast.error(e);
      }

      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
    },
    emojiOptions() {
      window.HyreadsEvents.emit(events.OPEN_REACTION);
    },
    openPicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
      this.pickerOpened = true;
    },
    closePicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
    },
    emojiPicked(emoji) {
      window.HyreadsEvents.emit(events.EMOJI_CHANGED, {
        emoji,
      });
      this.closePicker();
    },
    openReply() {
      var self = this;
      var message = this.message;
      window.HyreadsEvents.emit(events.NEW_REPLY, {
        message,
      });
      console.log("message", self.message);
    },
    deleteMessage() {
      var self = this;
      var message = { id: this.message.id, index: this.index };
      window.HyreadsEvents.emit(events.DELETE_MESSAGE, {
        message,
      });
    },
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 0;
}
.close:before,
.close:after {
  position: absolute;
  right: 15px;
  content: " ";
  height: 20px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.absolute {
  top: -65px;
  position: absolute;
  right: 0;
  left: 0;
}

.h-16 {
  height: 6rem;
}

.actions {
  border-radius: 25px;
  background-color: transparent;
  display: block;
  width: 20px;
  position: absolute;
  bottom: -30px;
  right: 0;
}

.w-8 {
  width: 1.2rem;
  height: 1.2rem;
  float: right;
  top: -10px;
}
</style>
